import {
  useUpdatePointOfInterestMutation,
  SelectedPointOfInterestDocument,
  ReportDetailsDocument,
} from '@/__generated__/graphql';
import { DocumentNode } from 'graphql';

export function usePoiRemediationNoteMutation() {
  const [updatePoi, { data, loading, error }] = useUpdatePointOfInterestMutation();

  const updateNote = async (
    remediationNote: string | undefined | null,
    pointOfInterestId: string,
    refetchQueries?: DocumentNode[]
  ) => {
    if (!pointOfInterestId) return;
    return updatePoi({
      variables: {
        input: {
          pointOfInterestId,
          remediationNote,
          lastModifiedFor: 'Update remediation note',
        },
      },
      refetchQueries: refetchQueries || [SelectedPointOfInterestDocument, ReportDetailsDocument],
    });
  };

  return { updateNote, data, loading, error };
}

